import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["gallery", "image", "images"];
  static values = { imagesData: Array };

  connect() {
    this.imageGalleryOpened = false;
    this.imageGalleryActiveUrl = null;
    this.imageGalleryImageIndex = null;
    this.imageGallery = this.imagesData ?? [];

    window.addEventListener(
      "image-gallery-next",
      this.imageGalleryNext.bind(this)
    );
    window.addEventListener(
      "image-gallery-prev",
      this.imageGalleryPrev.bind(this)
    );
    window.addEventListener("keyup", this.handleKeyup.bind(this));
  }

  disconnect() {
    window.removeEventListener(
      "image-gallery-next",
      this.imageGalleryNext.bind(this)
    );
    window.removeEventListener(
      "image-gallery-prev",
      this.imageGalleryPrev.bind(this)
    );
    window.removeEventListener("keyup", this.handleKeyup.bind(this));
  }

  imageGalleryOpen(event) {
    this.imageGalleryImageIndex = event.target.dataset.index;
    this.imageGalleryActiveUrl = event.target.src;
    this.imageGalleryOpened = true;
    this.updateGallery();
  }

  imageGalleryClose() {
    this.imageGalleryOpened = false;
    setTimeout(() => {
      this.imageGalleryActiveUrl = null;
      this.updateGallery();
    }, 300);
  }

  imageGalleryNext() {
    this.imageGalleryImageIndex =
      this.imageGalleryImageIndex == this.imageGallery.length
        ? 1
        : parseInt(this.imageGalleryImageIndex) + 1;
    this.imageGalleryActiveUrl = this.galleryTarget.querySelector(
      `[data-index='${this.imageGalleryImageIndex}']`
    ).src;
    this.updateGallery();
  }

  imageGalleryPrev() {
    this.imageGalleryImageIndex =
      this.imageGalleryImageIndex == 1
        ? this.imageGallery.length
        : parseInt(this.imageGalleryImageIndex) - 1;
    this.imageGalleryActiveUrl = this.galleryTarget.querySelector(
      `[data-index='${this.imageGalleryImageIndex}']`
    ).src;
    this.updateGallery();
  }

  handleKeyup(event) {
    if (event.key === "ArrowRight") {
      this.imageGalleryNext();
    } else if (event.key === "ArrowLeft") {
      this.imageGalleryPrev();
    } else if (event.key === "Escape") {
      this.imageGalleryClose();
    }
  }

  updateGallery() {
    this.imageTargets.forEach((image) => {
      image.src = this.imageGalleryActiveUrl;
      image.style.display = this.imageGalleryOpened ? "block" : "none";
    });
  }
}
